export const PERIOD_DISPLAY = {
    ONE_HOUR: '1H',
    FOUR_HOURS: '4H',
    ONE_DAY: '1D',
    ONE_WEEK: '1W',
    TWO_WEEKS: '2W',
    ONE_MONTH: '1M',
    THREE_MONTHS: '3M',
    ONE_YEAR: '1Y',
};
export const PERIOD_IN_HOURS = {
    ONE_HOUR: 1,
    FOUR_HOURS: 4,
    ONE_DAY: 24,
    ONE_MONTH: 672,
    ONE_WEEK: 168,
    TWO_WEEKS: 336,
    THREE_MONTHS: 2016,
    ONE_YEAR: 8766,
};
export const PERIOD_IN_SECONDS = {
    ONE_HOUR: 60 * 60,
    FOUR_HOURS: 4 * 60 * 60,
    ONE_DAY: 24 * 60 * 60,
    ONE_MONTH: 672 * 60 * 60,
    THREE_MONTHS: 2016 * 60 * 60,
    ONE_WEEK: 168 * 60 * 60,
    TWO_WEEKS: 336 * 60 * 60,
    ONE_YEAR: 8766 * 60 * 60,
};
export const SECONDS_PER_DAY = 24 * 60 * 60;
export const MILLISECONDS_PER_DAY = SECONDS_PER_DAY * 1000;
//# sourceMappingURL=period.js.map